import { UnitType } from '@exodus/currency'

const name = 'nano'
const displayName = 'Nano'
const ticker = 'NANO'
const displayTicker = 'XNO'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#209CE9'
const gradientColors = ['#209CE9', '#7CB3FD']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  raw: 0,
  NANO: 30,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://nanocrawler.cc/explorer/account/${encodeURIComponent(address)}/history`,
  txUrl: (txId) => `https://nanocrawler.cc/explorer/block/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Nano is a fast and fee-less cryptocurrency. Each individual user provides the computational power for the verification of their own transactions, meaning the entire network is not required to update the overall ledger together in massive blocks.',
  reddit: 'https://www.reddit.com/r/nanocurrency',
  twitter: 'https://twitter.com/nano',
  website: 'https://nano.org/en',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
